/**
 * Re-export base handlers
 */

export { QueryHandlerBase } from './query-handler.base';
export { EditHandlerBase } from './edit-handler.base';
